export const MENU = {
  MENU_ITEM: 'menu-item',
  MENU_CONTAINER: 'menu-container',
  MENU_ITEM_TOOLTIP: 'menu-item-tooltip'
} as const;
